module.exports = __webpack_public_path__ + "img/lbl-01.1583fac7.png";